import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function RoleProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, isInitialized, user } = useAuth();

  // Wait for auth initialization from localStorage
  if (!isInitialized) {
    return <div className="sessions-status">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If allowedRoles is specified, check if user's role is allowed
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate profile based on role
    const redirectTo = user?.role === 'player' ? '/player-profile' : '/provider-profile';
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

export default RoleProtectedRoute;
